module.exports = __webpack_public_path__ + "static/img/dr-ahmed.24432329.jpg";